// extracted by mini-css-extract-plugin
module.exports = {"musicControl":"music-control-box_musicControl__3A-n5","button":"music-control-box_button__NExEz"};